/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HistoryResponse } from '../models/HistoryResponse';
import type { TaskName } from '../models/TaskName';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HistoryRoutesRepository {
  /**
   * Get All History
   * Lists all histories.
   * @returns HistoryResponse Successful Response
   * @throws ApiError
   */
  public static historyRoutesGetAllHistory({
    jobId,
    authorization,
  }: {
    jobId: string,
    authorization?: string,
  }): CancelablePromise<Array<HistoryResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/history/{job_id}',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Task History By Task Names
   * Lists histories from the given job tasks.
   * @returns HistoryResponse Successful Response
   * @throws ApiError
   */
  public static historyRoutesGetTaskHistoryByTaskNames({
    jobId,
    taskNames,
    authorization,
  }: {
    jobId: string,
    taskNames: Array<TaskName>,
    authorization?: string,
  }): CancelablePromise<Array<HistoryResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/history/{job_id}/tasks',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'task_names': taskNames,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Task History
   * Lists all histories.
   * @returns HistoryResponse Successful Response
   * @throws ApiError
   */
  public static historyRoutesGetTaskHistory({
    jobId,
    taskId,
    authorization,
  }: {
    jobId: string,
    taskId: string,
    authorization?: string,
  }): CancelablePromise<Array<HistoryResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/history/{job_id}/{task_id}',
      path: {
        'job_id': jobId,
        'task_id': taskId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
